import React, { forwardRef, useEffect } from 'react';
import { fromTheme } from '@kyruus/ui-theme';
import { withRouter } from 'react-router-dom';
import Cancel from '@kyruus/react-ikons/Cancel';
import { DIRECTBOOK_DRAWER_CLOSED } from '../../direct-booking/tracking';
import { getReasonForDirectBookDrawerClosure } from '../../direct-booking/utils';
import {
  DBDrawerCloseButtonWithDBHeader,
  DBDrawerContent
} from 'Src/shared/direct-book-drawer/styles';
import { DirectBookWidgetHeaderWithProviderDetails } from 'Src/shared/direct-book-drawer/direct-book-widget-header-with-provider-details';
import { APP_DRAWER_IDS, AppDrawer, useAppDrawer } from 'Src/app-drawer';
import { useIntl } from '@kyruus/intl';
import { messages } from '../messages';

const DirectBookDrawerBase = withRouter(
  ({ forwardedRef, provider, config, history, children, log, ...props }) => {
    const { openAppDrawer, closeAppDrawer } = useAppDrawer();
    const intl = useIntl();

    const closeButtonSize = fromTheme('font_size_heading_3')(props);
    const closeButtonColor = fromTheme('color_text_secondary')(props);
    const handleClose = (event, reason) => {
      const closureReason = getReasonForDirectBookDrawerClosure(reason);
      log(DIRECTBOOK_DRAWER_CLOSED, { method: closureReason });
      closeAppDrawer();
      history.goBack();
    };
    useEffect(() => {
      if (provider) {
        // this timeout is needed for the drawer animation to work properly
        setTimeout(() => {
          openAppDrawer(APP_DRAWER_IDS.DIRECT_BOOK_DRAWER);
        }, 1);
      }
    }, [provider]);

    if (!provider) {
      return null;
    }

    const useDirectBookV2 =
      config?.darkship_feature_flags &&
      config?.darkship_feature_flags?.use_direct_book_v2;

    const closeDrawerAriaLabel = intl.formatMessage(
      messages.closeDirectBookDrawerAriaLabel
    );

    const renderHeader = () => {
      if (useDirectBookV2) {
        return (
          <DBDrawerCloseButtonWithDBHeader
            aria-label={closeDrawerAriaLabel}
            data-testid="db_drawer_close_button_with_db_header"
            mode="flat"
            onClick={handleClose}
          >
            <Cancel
              aria-hidden={true}
              size={closeButtonSize}
              color={closeButtonColor}
            />
          </DBDrawerCloseButtonWithDBHeader>
        );
      }

      return (
        <DirectBookWidgetHeaderWithProviderDetails
          provider={provider}
          closeButtonSize={closeButtonSize}
          closeButtonColor={closeButtonColor}
          handleClose={handleClose}
        />
      );
    };
    return (
      <AppDrawer
        {...props}
        id={APP_DRAWER_IDS.DIRECT_BOOK_DRAWER}
        onClose={handleClose}
      >
        {renderHeader()}
        <DBDrawerContent ref={forwardedRef}>{children}</DBDrawerContent>
      </AppDrawer>
    );
  }
);

export const DirectBookDrawer = forwardRef((props, ref) => (
  <DirectBookDrawerBase {...props} forwardedRef={ref} />
));

DirectBookDrawer.displayName = 'DirectBookDrawer';
